(function () {
  function getPhoneModels() {
    return window.PhoneModels || {};
  }

  function getLabelFromSelect(select) {
    const selectedOption = select && select.options ? select.options[select.selectedIndex] : null;
    return (selectedOption && (selectedOption.dataset.modelLabel || selectedOption.textContent)) || "";
  }

  function applyModelConfig(modelKey, label) {
    const config = getPhoneModels()[modelKey];

    document.querySelectorAll("[data-custom-device]").forEach((node) => {
      node.textContent = label;
    });

    document.querySelectorAll("[data-phone-model-input]").forEach((input) => {
      input.value = label;
    });

    document.querySelectorAll("[data-phone-brand-input]").forEach((input) => {
      input.value = "Apple";
    });

    document.querySelectorAll("[data-phone-model-key-input]").forEach((input) => {
      input.value = modelKey;
    });

    document.querySelectorAll("[data-phone-preview-frame]").forEach((frame) => {
      if (!config) {
        return;
      }

      frame.style.setProperty("--phone-frame-ratio", String(config.frameRatio || 0.49));
      frame.style.setProperty("--phone-shell-radius", `${config.shellRadius || 26}px`);
      frame.style.setProperty("--phone-safe-top", `${config.safeZone.top}%`);
      frame.style.setProperty("--phone-safe-left", `${config.safeZone.left}%`);
      frame.style.setProperty("--phone-safe-width", `${config.safeZone.width}%`);
      frame.style.setProperty("--phone-safe-height", `${config.safeZone.height}%`);
      frame.style.setProperty("--phone-camera-top", `${config.camera.top}%`);
      frame.style.setProperty("--phone-camera-left", `${config.camera.left}%`);
      frame.style.setProperty("--phone-camera-width", `${config.camera.width}%`);
      frame.style.setProperty("--phone-camera-height", `${config.camera.height}%`);
      frame.style.setProperty("--phone-camera-radius", `${config.camera.radius}%`);

      const shell = frame.querySelector("[data-phone-shell]");
      if (shell) {
        shell.dataset.cameraLayout = config.camera.style || "dual";
      }
    });
  }

  function syncVariantSelection(variantId, label) {
    document.querySelectorAll("[data-variant-button]").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.variantId === variantId);
    });

    document.querySelectorAll("[data-variant-id-input]").forEach((input) => {
      input.value = variantId;
    });

    applyModelConfig((label || "").toLowerCase().replace(/\s+/g, "-"), label);
  }

  function syncCatalogModel(modelKey, label) {
    document.querySelectorAll("[data-model-select]").forEach((select) => {
      if (select.value !== modelKey) {
        select.value = modelKey;
      }
    });

    applyModelConfig(modelKey, label);
  }

  function updateMode(mode) {
    document.querySelectorAll("[data-design-toggle] .toggle-btn").forEach((button) => {
      button.classList.toggle("is-active", button.dataset.mode === mode);
    });

    document.querySelectorAll("[data-design-panel]").forEach((panel) => {
      const active = panel.dataset.designPanel === mode;
      panel.hidden = !active;
    });

    document.querySelectorAll("[data-design-type-input]").forEach((input) => {
      input.value = mode;
    });

    document.querySelectorAll("[data-submit-label]").forEach((button) => {
      button.textContent = mode === "custom" ? "Save & Add to cart" : "Add to cart";
    });

    if (mode === "custom") {
      const customPanel = document.querySelector('[data-design-panel="custom"]');
      if (customPanel) {
        customPanel.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  function bindUploads() {
    document.querySelectorAll("[data-upload-input]").forEach((input) => {
      input.addEventListener("change", () => {
        const file = input.files && input.files[0];
        const parent = input.closest(".product-form") || document;
        const preview = parent.querySelector("[data-upload-preview]");
        const previewImage = parent.querySelector("[data-upload-preview-image]");
        const previewName = parent.querySelector("[data-upload-name]");
        const previewStatus = parent.querySelector("[data-preview-status]");
        const placeholder = parent.querySelector("[data-upload-placeholder]");

        if (!file || !preview || !previewImage || !previewName) {
          return;
        }

        const objectUrl = URL.createObjectURL(file);
        preview.hidden = false;
        previewImage.src = objectUrl;
        previewImage.alt = file.name;
        previewImage.hidden = false;
        previewName.textContent = file.name;
        if (placeholder) {
          placeholder.hidden = true;
        }

        if (previewStatus) {
          previewStatus.textContent = "Preview ready";
        }
      });
    });
  }

  function updatePreviewTransforms(form) {
    const image = form.querySelector("[data-upload-preview-image]");
    const scaleInput = form.querySelector("[data-scale-input]");
    const rotateInput = form.querySelector("[data-rotate-input]");
    const offsetXInput = form.querySelector("[data-offset-x-input]");
    const offsetYInput = form.querySelector("[data-offset-y-input]");
    const scaleOutput = form.querySelector("[data-scale-output]");
    const rotationOutput = form.querySelector("[data-rotation-output]");
    const offsetXOutput = form.querySelector("[data-offset-x-output]");
    const offsetYOutput = form.querySelector("[data-offset-y-output]");

    if (!image || !scaleInput || !rotateInput || !offsetXInput || !offsetYInput) {
      return;
    }

    const scale = Number(scaleInput.value || 100) / 100;
    const rotation = Number(rotateInput.value || 0);
    const offsetX = Number(offsetXInput.value || 0);
    const offsetY = Number(offsetYInput.value || 0);

    image.style.setProperty("--custom-scale", String(scale));
    image.style.setProperty("--custom-rotate", `${rotation}deg`);
    image.style.setProperty("--custom-offset-x", `${offsetX}%`);
    image.style.setProperty("--custom-offset-y", `${offsetY}%`);

    if (scaleOutput) {
      scaleOutput.value = `${Math.round(scale * 100)}%`;
    }
    if (rotationOutput) {
      rotationOutput.value = `${rotation}deg`;
    }
    if (offsetXOutput) {
      offsetXOutput.value = `${offsetX}%`;
    }
    if (offsetYOutput) {
      offsetYOutput.value = `${offsetY}%`;
    }
  }

  function bindCustomControls() {
    document.querySelectorAll(".product-form--custom").forEach((form) => {
      form.querySelectorAll("[data-scale-input], [data-rotate-input], [data-offset-x-input], [data-offset-y-input]").forEach((input) => {
        input.addEventListener("input", () => updatePreviewTransforms(form));
      });

      form.addEventListener("submit", (event) => {
        const uploadInput = form.querySelector("[data-upload-input]");
        if (uploadInput && (!uploadInput.files || uploadInput.files.length === 0)) {
          event.preventDefault();
          uploadInput.focus();
          const previewStatus = form.querySelector("[data-preview-status]");
          if (previewStatus) {
            previewStatus.textContent = "Upload an image first";
          }
        }
      });

      updatePreviewTransforms(form);
    });
  }

  function getInitialMode() {
    const url = new URL(window.location.href);
    if (url.searchParams.get("mode") === "custom") {
      return "custom";
    }
    if (url.hash === "#customise" || url.hash === "#custom") {
      return "custom";
    }
    return "readymade";
  }

  function initializeModelState() {
    const activeVariantButton = document.querySelector("[data-variant-button].is-active");
    if (activeVariantButton) {
      syncVariantSelection(activeVariantButton.dataset.variantId, activeVariantButton.dataset.modelLabel);
      return;
    }

    const modelSelect = document.querySelector("[data-model-select]");
    if (modelSelect) {
      syncCatalogModel(modelSelect.value, getLabelFromSelect(modelSelect));
    }
  }

  function bindInteractions() {
    document.querySelectorAll("[data-variant-button]").forEach((button) => {
      button.addEventListener("click", () => {
        syncVariantSelection(button.dataset.variantId, button.dataset.modelLabel);
      });
    });

    document.querySelectorAll("[data-model-select]").forEach((select) => {
      select.addEventListener("change", () => {
        syncCatalogModel(select.value, getLabelFromSelect(select));
      });
    });

    document.querySelectorAll("[data-design-toggle] .toggle-btn").forEach((button) => {
      button.addEventListener("click", () => {
        updateMode(button.dataset.mode);
      });
    });

    initializeModelState();
    updateMode(getInitialMode());
    bindUploads();
    bindCustomControls();
  }

  function bindMenuToggle() {
    const toggle = document.querySelector(".site-header__menu-toggle");
    const nav = document.querySelector(".site-header__nav");

    if (!toggle || !nav) {
      return;
    }

    toggle.addEventListener("click", () => {
      const expanded = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!expanded));
      nav.style.display = expanded ? "" : "block";
    });
  }

  function bindRevealObserver() {
    const nodes = document.querySelectorAll("[data-reveal]");
    if (!nodes.length || !("IntersectionObserver" in window)) {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.16, rootMargin: "0px 0px -8% 0px" }
    );

    nodes.forEach((node) => observer.observe(node));
  }

  function bindHeroParallax() {
    var hero = document.querySelector(".hero-banner");

    if (!hero || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    var targetX = 72, targetY = 40;
    var currentX = 72, currentY = 40;
    var rafId = 0;
    var ease = 0.12;

    function tick() {
      currentX += (targetX - currentX) * ease;
      currentY += (targetY - currentY) * ease;
      hero.style.setProperty("--glow-x", currentX.toFixed(1) + "%");
      hero.style.setProperty("--glow-y", currentY.toFixed(1) + "%");

      if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
        rafId = requestAnimationFrame(tick);
      } else {
        hero.style.setProperty("--glow-x", targetX + "%");
        hero.style.setProperty("--glow-y", targetY + "%");
        rafId = 0;
      }
    }

    function startLoop() {
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    document.addEventListener("pointermove", function (event) {
      var rect = hero.getBoundingClientRect();
      if (event.clientY > rect.bottom) return;
      targetX = ((event.clientX - rect.left) / rect.width) * 100;
      targetY = ((event.clientY - rect.top) / rect.height) * 100;
      startLoop();
    });
  }

  function bindCustomiserWizard() {
    var wizard = document.querySelector(".cst-wizard");
    if (!wizard) return;

    var currentStep = 1;
    var selectedBrand = null;
    var selectedModelKey = null;
    var selectedModelLabel = null;

    function goToStep(num) {
      var prev = wizard.querySelector('.cst-step.is-active');
      var next = wizard.querySelector('.cst-step[data-step="' + num + '"]');
      if (!next || prev === next) return;

      if (prev) {
        prev.classList.remove("is-active");
        prev.classList.add("is-exit");
        prev.setAttribute("aria-hidden", "true");
        var prevNum = parseInt(prev.dataset.step, 10);
        setTimeout(function () {
          prev.classList.remove("is-exit");
        }, 420);
      }

      next.classList.add("is-active");
      next.removeAttribute("aria-hidden");
      currentStep = num;

      wizard.querySelectorAll(".cst-progress__step").forEach(function (dot) {
        var n = parseInt(dot.dataset.stepIndicator, 10);
        dot.classList.toggle("is-active", n === num);
        dot.classList.toggle("is-done", n < num);
      });

      wizard.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    wizard.addEventListener("click", function (e) {
      var brandBtn = e.target.closest("[data-brand]");
      if (brandBtn) {
        selectedBrand = brandBtn.dataset.brand;
        var nextStep = parseInt(brandBtn.dataset.nextStep, 10);
        if (!isNaN(nextStep)) goToStep(nextStep);
        return;
      }

      var modelBtn = e.target.closest(".cst-model-card[data-model-key]");
      if (modelBtn) {
        wizard.querySelectorAll(".cst-model-card").forEach(function (c) {
          c.classList.remove("is-selected");
        });
        modelBtn.classList.add("is-selected");
        selectedModelKey = modelBtn.dataset.modelKey;
        selectedModelLabel = modelBtn.dataset.modelLabel;

        var displayEl = wizard.querySelector("[data-display-model]");
        if (displayEl) displayEl.textContent = selectedModelLabel;

        var browseLink = wizard.querySelector("[data-browse-link]");
        if (browseLink) {
          browseLink.href = "/collections/all?model=" + selectedModelKey;
        }
        var uploadLink = wizard.querySelector("[data-upload-link]");
        if (uploadLink) {
          uploadLink.href = "/collections/all?mode=custom&model=" + selectedModelKey;
        }

        var nextStep = parseInt(modelBtn.dataset.nextStep, 10);
        if (!isNaN(nextStep)) {
          setTimeout(function () { goToStep(nextStep); }, 140);
        }
        return;
      }

      var backBtn = e.target.closest("[data-prev-step]");
      if (backBtn) {
        var prevStep = parseInt(backBtn.dataset.prevStep, 10);
        if (!isNaN(prevStep)) goToStep(prevStep);
        return;
      }
    });

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var targetX = 55, targetY = 30;
      var currentX = 55, currentY = 30;
      var rafIdW = 0;
      var easeW = 0.1;

      function tickW() {
        currentX += (targetX - currentX) * easeW;
        currentY += (targetY - currentY) * easeW;
        wizard.style.setProperty("--glow-x", currentX.toFixed(1) + "%");
        wizard.style.setProperty("--glow-y", currentY.toFixed(1) + "%");
        if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
          rafIdW = requestAnimationFrame(tickW);
        } else {
          rafIdW = 0;
        }
      }

      document.addEventListener("pointermove", function (ev) {
        var rect = wizard.getBoundingClientRect();
        if (ev.clientY < rect.top || ev.clientY > rect.bottom) return;
        targetX = ((ev.clientX - rect.left) / rect.width) * 100;
        targetY = ((ev.clientY - rect.top) / rect.height) * 100;
        if (!rafIdW) rafIdW = requestAnimationFrame(tickW);
      });
    }

    var urlParams = new URLSearchParams(window.location.search);
    var preModel = urlParams.get("model");
    if (preModel) {
      var preBtn = wizard.querySelector('.cst-model-card[data-model-key="' + preModel + '"]');
      if (preBtn) preBtn.click();
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindInteractions();
    bindMenuToggle();
    bindRevealObserver();
    bindHeroParallax();
    bindCustomiserWizard();
  });
})();
